<template>
  <el-tooltip class="item" effect="dark" :open-delay="200" :placement="isPosition">
    <!-- 使用 slot -->
    <template #content>
      <div :style="{ maxWidth: popMaxWidthPx }">
        <!-- 向父组件提供 slot -->
        <slot name="content">
          <span v-if="tips" v-html="tips"></span>
          <!-- <p v-html="tips" :style="{width: width + 'px', }" ></p> -->
        </slot>
      </div>
    </template>

    <span v-if="!tipsFlag">{{ tipsLabel }}</span>
    <i
      v-if="tipsFlag"
      class="icon-item"
      :class="iconClass"
      :style="{
        position: position,
        fontSize: fontS + 'px',
        color: color,
        fontWeight: 400,
      }"
    ></i>
  </el-tooltip>
</template>
<script>import { isNumber, isString } from 'xe-utils'

export default {
  data() {
    return {
      isShow: false,
      tipData: '<div>22</div>'
    }
  },
  props: {
    // 提示文本
    tips: {
      type: String
    },
    tipsLabel: {
      type: String
    },
    /**
     * 出现位置
     * top/top-start/top-end/bottom/bottom-start/bottom-end/left/left-start/left-end/right/right-start/right-end
     */
    isPosition: {
      type: String,
      default: 'top'
    },
    // 宽度
    width: {
      type: [Number, String],
      default: 100
    },
    position: {
      type: String,
      default: 'inherit'
    },
    fontS: {
      type: Number,
      default: 14
    },
    iconClass: {
      type: String,
      default: 'iconhuice icon-wenhao'
    },
    tipsFlag: {
      type: Boolean,
      default: true
    },
    color: {
      type: String,
      default: '#919499'
    }
  },
  computed: {
    popMaxWidthPx() {
      if (isString(this.width)) {
        return this.width
      }

      if (isNumber(this.width)) {
        return this.width + 'px'
      }

      return '20px'
    }
  },
  created() {
    /* 处理文字自动换行 */
    // let m = Math.floor(this.width / 12)
    // let l = this.tips.length
    // let n = Math.ceil(l/m)
    // let d = ''
    // for (let i = 1; i <= n; i++) {
    //   let a = this.tips.substr(m*(i-1),m) + `<br/>`
    //   d += a
    // }
    // this.tipData = d
  }
}
</script>
<style lang="scss" scpoed>
// .item{
//   margin-left: 2px;
// }
.icon-item{
  margin-left: 4px;
}
</style>
